/// <amd-module name="Test/TestCaseResults/Redux/TestCaseResultsModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

import { TestCaseResultsActions } from "./TestCaseResultsActions";
import { ITestCaseResultsAwareState } from "./TestCaseResultsContracts";
import { TestCaseResultsFilterReducer } from "./TestCaseResultsFilterReducer";
import { TestCaseResultsReducer } from "./TestCaseResultsReducer";
import { TestCaseResultsSaga } from "./TestCaseResultsSaga";

export const TestCaseResultsModule: ISagaModule<ITestCaseResultsAwareState> = {
    id: "testplan-clone-panel",
    reducerMap: {
        testCaseResultsState: TestCaseResultsReducer,
        testCaseResultsFilterState: TestCaseResultsFilterReducer
    },
    initialActions: [TestCaseResultsActions.loadInitialResultsData()],
    sagas: [TestCaseResultsSaga]
};
